import { render, staticRenderFns } from "./MyLifestyle.vue?vue&type=template&id=39896cf4"
import script from "./MyLifestyle.vue?vue&type=script&lang=js"
export * from "./MyLifestyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports